/**
 * Audit themes per hospital — Firestore: audit_themes/{hospitalId}/themes/{themeId}
 * Security rules: see firestore.rules (PASUL 0 CURSOR_PROMPT_AuditForm)
 */

import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  setDoc,
  updateDoc,
  Timestamp
} from 'firebase/firestore';
import { db } from '../firebase';

function themesCol(hospitalId) {
  return collection(db, 'audit_themes', hospitalId, 'themes');
}

export const auditThemeService = {
  async getThemes(hospitalId) {
    if (!hospitalId) return [];
    const q = query(
      themesCol(hospitalId),
      where('isActive', '==', true),
      orderBy('label', 'asc')
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  },

  async getAllThemes(hospitalId) {
    if (!hospitalId) return [];
    const q = query(themesCol(hospitalId), orderBy('label', 'asc'));
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  },

  async addTheme(hospitalId, { label, category }) {
    if (!hospitalId || !label?.trim()) throw new Error('label is required');
    const ref = doc(themesCol(hospitalId));
    const payload = {
      id: ref.id,
      label: label.trim(),
      category: category || 'General',
      isDefault: false,
      isActive: true,
      createdAt: Timestamp.now()
    };
    await setDoc(ref, payload);
    return ref.id;
  },

  async deactivateTheme(hospitalId, themeId) {
    const ref = doc(db, 'audit_themes', hospitalId, 'themes', themeId);
    const one = await getDoc(ref);
    if (!one.exists()) throw new Error('Theme not found');
    const data = one.data();
    if (data.isDefault) {
      throw new Error('Cannot deactivate default theme');
    }
    await updateDoc(ref, { isActive: false });
  },

  async activateTheme(hospitalId, themeId) {
    const ref = doc(db, 'audit_themes', hospitalId, 'themes', themeId);
    await updateDoc(ref, { isActive: true });
  }
};
